/*
  Панель страниц для списка, который режет на страницы сам сервер (реестр должников;
  21.10.2026, замечание владельца: «пагинация и количество записей в любой список»).

  Замена `RegistryPager.jsx`: у реестра свой запрос со смещением (`offset`, он живёт в
  адресе страницы), и `usePaging` с его нарезкой готового списка тут не годится. Панель
  та же, что у остальных списков, - `PageBar`; этот хук только собирает ей свойства
  из смещения и числа записей, которое сообщил сервер.

  Размер страницы выбирается из тех же 10, 25, 50 и 100 и запоминается один на все
  списки кабинета. Сервер принимает до 500 (`MAX_PAGE_SIZE` в `schemas/queries.py`),
  так что весь список размеров допустим. Смена размера возвращает на первую страницу:
  смещение, кратное прежнему размеру, на новом указывало бы в середину страницы.
*/

import { useState } from 'react'

import { rememberPageSize, storedPageSize } from './usePaging.js'

/*
  `offset` - текущее смещение (из адреса страницы), `total` - сколько записей сказал
  сервер, `onOffset(число)` - перейти на смещение (0 - первая страница).
*/
export default function useServerPaging(offset, total, onOffset, initialSize = 10) {
  const [size, setSize] = useState(() => storedPageSize(initialSize))

  const onSize = (value) => {
    const next = Number(value)
    rememberPageSize(next)
    setSize(next)
    onOffset(0)
  }

  return {
    size,
    bar: {
      total,
      size,
      page: Math.floor(offset / size),
      pages: Math.max(1, Math.ceil(total / size)),
      onPage: (number) => onOffset(number * size),
      onSize,
    },
  }
}
